const SET_LOCAL_ANSWER = '[exam][question]set.local.answer';											// used to determine client-side which answer was selected
const SET_SERVER_ANSWER = '[exam][question]set.server.answer';										// contains 'answerText' and 'options' for saving to server
const TOGGLE_BOOKMARK = '[exam][question]toggle.bookmark';

export {SET_LOCAL_ANSWER, SET_SERVER_ANSWER, TOGGLE_BOOKMARK}